import RustyNails from '../assets/Moderat - Rusty Nails.mp3'
import ANewError from '../assets/Moderat - A New Error.mp3'
import K from '../assets/coffee-after-cigs-K.mp3'
import EverybodyKnows from '../assets/leonard-cohen-everybody-knows.mp3'
import HappensToTheHeart from '../assets/leonard-cohen-happens-to-the-heart.mp3'

export const song_list = [
  {
    id: 0,
    name: 'K.',
    artists: {
      name: 'Cigarettes After Sex',
    },
    file: K,
    picUrl: 'cigs-after-sex.jpeg',
    length: '05:20'
  },
  {
    id: 1,
    name: 'Everybody Knows',
    artists: {
      name: 'Leonard Cohen',
    },
    file: EverybodyKnows,
    picUrl: 'everybody-knows.jpeg',
    length: '05:38'
  },
  {
    id: 2,
    name: 'Happens to the Heart',
    artists: {
      name: 'Leonard Cohen',
    },
    file: HappensToTheHeart,
    picUrl: 'happens-to-the-heart.jpeg',
    length: '04:34'
  },
  {
    id: 3,
    name: 'Rusty Nails',
    artists: {
      name: 'Moderat',
    },
    file: RustyNails,
    picUrl: 'rusty-nails.jpg',
    length: '04:32'
  }, {
    id: 4,
    name: 'A New Error',
    artists: {
      name: 'Moderat',
    },
    file: ANewError,
    picUrl: 'a-new-error.jpg',
    length: '04:21'
  },
]